import TaxonomySubject from '../implementations/Taxonomy/Subject';
import TaxonomyMilestone from '../implementations/Taxonomy/Milestone';
import TaxonomyCampaign from '../implementations/Taxonomy/Campaign';
import TaxonomyChainapproach from '../implementations/Taxonomy/Chainapproach';
import TaxonomyTheme from '../implementations/Taxonomy/Theme';
import TaxonomyPillar from '../implementations/Taxonomy/Pillar';
import TaxonomyActivity from '../implementations/Taxonomy/Activity';

const mappers = {
  subject: TaxonomySubject,
  workfield: TaxonomySubject,
  stage_of_life: TaxonomySubject,
  locatie: TaxonomySubject,
  milestones: TaxonomyMilestone,
  campaign: TaxonomyCampaign,
  chainapproach: TaxonomyChainapproach,
  thema: TaxonomyTheme,
  pillar: TaxonomyPillar,
  activity: TaxonomyActivity,
};

export default mappers;
